import * as React from "react"
import { InjectedIntlProps, injectIntl, FormattedNumber } from "react-intl"
import { bodyW } from "../../pptx-configuration/constants"
import * as CommonUtils from "../../utils"
import * as Conf from "../../../configuration"
import * as InvestmentDomain from "../../../../../domain/sfp/investment-domain"


class InvestmentTable
extends React.Component<InvestmentTableProps & InjectedIntlProps> {
	private readonly labelCellWidth: number
	private readonly valueCellWidth: number

	constructor(props: InvestmentTableProps & InjectedIntlProps) {
		super(props)

		this.labelCellWidth = CommonUtils.toInches(5.2)
		this.valueCellWidth = (bodyW - this.labelCellWidth)
		/ (props.years.length + 1)
	}

	render() {
		const currency = this.props.currency
		const data = this.props.investmentData
		const id = this.props.id
		const locale = this.props.locale
		const roundness = this.props.roundness
		const tableConf = this.props.tableConfiguration
		const years = this.props.years

		return <table id={id}>
			<thead>
				<tr>
					<th data-pptx-width={this.labelCellWidth}
					style={{ ...tableConf.header}}></th>

					{years.map((year, yearIndex) =>
					<th data-pptx-width={this.valueCellWidth}
					key={yearIndex}
					style={{ ...tableConf.header}}>{year}</th>)}

					<th data-pptx-width={this.valueCellWidth}
					style={{ ...tableConf.header}}>Total</th>
				</tr>
			</thead>

			<tbody>
				{data.map((row, rowIndex) =>
				this.props.enableHideZeroLines
				? CommonUtils.isArrayAllValuesZero(row.values) === false && (
				<tr key={rowIndex} hidden={this.props.enableHideZeroLines && CommonUtils.isArrayAllValuesZero(row.values) === false } >
					<td style={{ ...tableConf.common }}>{row.label}</td>
					{row.values.map((value, valueIndex) =>
					<td
					key={valueIndex}
					style={{ ...tableConf.common, ...tableConf.numeric }}>
						{CommonUtils.formatCurrency(locale, currency, value, roundness)}
					</td>)}

					<td style={{ ...tableConf.total, ...tableConf.numeric }}>
						{CommonUtils.formatCurrency(locale, currency, row.total, roundness)}
					</td>
				</tr>)
				:
				(<tr key={rowIndex} >
					<td style={{ ...tableConf.common }}>{row.label}</td>

					{row.values.map((value, valueIndex) =>
					<td
					key={valueIndex}
					style={{ ...tableConf.common, ...tableConf.numeric }}>
						{CommonUtils.formatCurrency(locale, currency, value, roundness)}
					</td>)}

					<td style={{ ...tableConf.total, ...tableConf.numeric }}>
						{CommonUtils.formatCurrency(locale, currency, row.total, roundness)}
					</td>
				</tr>)
				)}
			</tbody>
		</table>
	}
}

export default injectIntl(InvestmentTable)

export interface InvestmentTableProps {
	currency: string
	id: string
	investmentData: InvestmentDomain.InvestmentData
	locale: string
	roundness: Conf.RoundnessValue
	enableHideZeroLines: boolean
	tableConfiguration: Conf.TableConfiguration
	years: number[]
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/investment-generator/investment-table.tsx